import { render } from "./SeminairePage.vue?vue&type=template&id=1613c4ed"
import script from "./SeminairePage.vue?vue&type=script&lang=js"
export * from "./SeminairePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__